/**
 * @generated SignedSource<<72867777d460b3e01c080c7c2bc6ad67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BranchSettingsDialog_pipeline$data = {
  readonly defaultBranch: string | null;
  readonly id: string;
  readonly name: string;
  readonly organization: {
    readonly name: string;
  };
  readonly " $fragmentType": "BranchSettingsDialog_pipeline";
};
export type BranchSettingsDialog_pipeline$key = {
  readonly " $data"?: BranchSettingsDialog_pipeline$data;
  readonly " $fragmentSpreads": FragmentRefs<"BranchSettingsDialog_pipeline">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BranchSettingsDialog_pipeline",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultBranch",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Pipeline",
  "abstractKey": null
};
})();

(node as any).hash = "7741e68d4cc320ed8ea6af538a5777be";

export default node;
